import _ from "lodash"

import { EntityField, RecordMaskField } from "@skinsoft/types"

const CORRECTED_PATH_REGEX = '\\.(\\d*\\.)*' // this regex matches the '.' in path.x and '.0.' in path.0.x

/**
 * 
 * @param entity 
 * @param maskFields 
 * @returns 
 */
export function getOnlyValuesFromMaskFields(
    entity: Object, 
    maskFields: RecordMaskField[],
    cleanValuesCallback?: (key: string, value: any, entityField: EntityField) => any
): Object {
    const result = {}
    
    const flattenEntity = flattenObjectProps(entity)
    const flattenEntityKeys = Object.keys(flattenEntity)

    loopThrewMaskfieldsAndGetValues(
        flattenEntity,
        flattenEntityKeys,
        maskFields,
        (key, value, entityField) => { 
            let cleanedValue = value
            if(cleanValuesCallback) {
                cleanedValue = cleanValuesCallback(key, value, entityField)
            }
            _.set(
                result,
                key,
                cleanedValue
            )
        }
    )

    return result
}

/**
 * 
 * @param flattenEntity 
 * @param flattenKeys 
 * @param maskFields 
 * @param callback 
 */
function loopThrewMaskfieldsAndGetValues(
    flattenEntity: any, 
    flattenKeys: string[], 
    maskFields: RecordMaskField[], 
    callback: (key: string, value: any, entityField: EntityField) => void
) {
    for(const maskField of maskFields) {
        const maskFieldPath = maskField.entityField.path

        const maskFieldPathRegex = maskFieldPath.replaceAll('.', CORRECTED_PATH_REGEX)
        // we add FINAL_INDEX_REGEX at the end for the case where the key finish by an index
        // ex: descriptionSchema.domain.0
        const FINAL_INDEX_REGEX = "(\\.\\d+)*"
        const correctPathRegex = new RegExp(`^${maskFieldPathRegex}${FINAL_INDEX_REGEX}$`)

        const keysThatMatch = flattenKeys.filter(key => {
            return correctPathRegex.test(key)
        })

        if(keysThatMatch.length) {
            for(const key of keysThatMatch) {
                callback(key, flattenEntity[key], maskField.entityField)
            }
        }
        
        if(maskField.children?.length) {
            loopThrewMaskfieldsAndGetValues(
                flattenEntity, 
                flattenKeys, 
                maskField.children,
                callback
            )
        }
    }
}

/**
 * 
 * @param {*} entity 
 * @returns {{[key: string]: any}}
 */
export function flattenObjectProps(entity) {
    let result = {}

    for(const [key, value] of Object.entries(entity)) {
        if(!_.isPlainObject(value) && !_.isArray(value)) {
            result[key] = value
        }
        else if("translatedString" in (value as any)) {
            result[key] = value
        }
        else if(_.isArray(value)) {
            if(value.length) {
                for(let index=0; index<value.length; index++) {
                    if(!_.isPlainObject(value[index]) && !_.isArray(value[index])) {
                        result[`${key}.${index}`] = value[index]   
                    }
                    else if(value[index].translatedString) {
                        result[`${key}.${index}`] = value[index]
                    } 
                    else {
                        const y = flattenObjectProps(value[index])
                        const yEntries = Object.entries(y)
                        if(yEntries.length) {
                            for(const [keyChild, valueChild] of yEntries) {
                                result[`${key}.${index}.${keyChild}`] = valueChild
                            }
                        } else {
                            result[`${key}.${index}`] = value[index]
                        }
                    }
                }
            } else {
                result[key] = value
            }
        }
        else {
            const x = flattenObjectProps(value)
            for(const [keyChild, valueChild] of Object.entries(x)) {
                result[`${key}.${keyChild}`] = valueChild
            }
        }
    }

    return result
}

/**
 * Removes keys 'item', 'manifestation', 'expression', and 'work' from a wemi
 * the content of the remove keys are extracted and still present in the object, directly at the top level
 * ex: {item: {a: 1}, manifestation: {b: 2}} => {a: 1, b: 2}
 * @param {Wemi} wemi 
 */
export function removeWemiPrefix(wemi) {
    return {
        ...wemi.item,
        ...wemi.manifestation,
        ...wemi.expression,
        ...wemi.work,
    }
}